import { get, getArrayBuffer, patch, post } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  retrieveCompaniesByType: (_, companyType) =>
    get(`companies-by-type/${companyType}`),

  retrieveCompanies: () => get('/companies'),

  getItemsList: ({ commit }, { params } = {}) => {
    return get('/companies', {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  retrieveCompany: (_, company) => get(`/companies/${company}`),

  store: (_, company) => post('/companies', company),

  update: (_, data) => patch(`/companies/${data.id}`, data),

  getOrders: (_, { companyId, params }) =>
    get(`/companies/${companyId}/orders`, params),

  getCompanyTypes({ commit }) {
    return get(`/company-types`).then(response => {
      commit('setCompanyTypes', response.data);

      return response;
    });
  },

  getCompanyStatuses({ commit }) {
    return get(`/filters/companies/statuses`).then(response => {
      commit('setCompanyStatuses', response.data);

      return response;
    });
  },

  getCompaniesExport(_, params) {
    return getArrayBuffer(`/companies-export`, params);
  }
};
